(() => {
  const deliverySelector = '.anyseal-delivery';
  const panelSelector = '[data-anyseal-delivery-panel]';
  const toggleSelector = '.anyseal-delivery__toggle';

  const setPanelHeight = (delivery) => {
    const panel = delivery.querySelector(panelSelector);
    const toggle = delivery.querySelector(toggleSelector);

    if (!panel || !toggle || toggle.getAttribute('aria-expanded') !== 'true') {
      return;
    }

    panel.style.maxHeight = `${panel.scrollHeight}px`;
  };

  const setExpanded = (delivery, expanded) => {
    const panel = delivery.querySelector(panelSelector);
    const toggle = delivery.querySelector(toggleSelector);

    if (!panel || !toggle) {
      return;
    }

    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    delivery.classList.toggle('is-collapsed', !expanded);

    if (expanded) {
      panel.style.maxHeight = `${panel.scrollHeight}px`;
      return;
    }

    panel.style.maxHeight = `${panel.scrollHeight}px`;

    requestAnimationFrame(() => {
      panel.style.maxHeight = '0px';
    });
  };

  const initDelivery = (delivery) => {
    if (delivery.dataset.anysealInitialized === 'true') {
      return;
    }

    const panel = delivery.querySelector(panelSelector);
    const toggle = delivery.querySelector(toggleSelector);

    if (!panel || !toggle) {
      return;
    }

    delivery.dataset.anysealInitialized = 'true';
    panel.style.maxHeight = `${panel.scrollHeight}px`;

    toggle.addEventListener('click', () => {
      setExpanded(delivery, toggle.getAttribute('aria-expanded') !== 'true');
    });

    panel.querySelectorAll('img').forEach((image) => {
      if (image.complete) {
        setPanelHeight(delivery);
        return;
      }

      image.addEventListener('load', () => setPanelHeight(delivery), { once: true });
    });
  };

  const init = (root = document) => {
    root.querySelectorAll(deliverySelector).forEach(initDelivery);
  };

  window.addEventListener('resize', () => {
    document.querySelectorAll(deliverySelector).forEach(setPanelHeight);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
